module.exports = __webpack_public_path__ + "static/media/advantage2.e3a6c4ea.png";